import { formatDate } from '@angular/common';
import {
  Component,
  EventEmitter,
  Inject,
  Input,
  OnInit,
  Optional,
  Output,
} from '@angular/core';
import {
  FormBuilder,
  FormGroup,
  Validators,
} from '@angular/forms';
import {
  MatDialog,
  MatDialogRef,
  MAT_DIALOG_DATA,
} from '@angular/material/dialog';
import { NgbDateParserFormatter } from '@ng-bootstrap/ng-bootstrap';
import { InfoCardComponent } from '../../shared/info-card/info-card.component';

@Component({
  selector: 'app-new-ticket',
  templateUrl: './new-ticket.component.html',
  styleUrls: ['./new-ticket.component.scss'],
})
export class NewTicketComponent implements OnInit {
  @Output() saveTickets = new EventEmitter<any>();
  entrada!: FormGroup;

  @Input() ticket!: any;
  @Input() levels: any[] = [];
  sessions: any[] = [];

  edit: boolean = false;

  idEvent!: any;

  priceTickets: any[] = [];
  singlePrice!: number;
  openAdvanced: boolean = false;
  openSpecialTickets: boolean = false;

  // Ticket special
  daysSpecial: boolean = false;
  ticketMembers: boolean = false;
  allowSubscription: boolean = false;
  allowTicketSpecial: boolean = false;

  datesOptions: any[] = [];
  hoursOptions: any[] = [];

  // Only tpv
  onlyTpv: boolean = false;
  ticketsLevels: any[] = [];
  selectedZones: any[] = [];
  previousZones: any[] = ['all'];
  selectedSessions: any[] = [];
  useMapVenue: boolean = false;
  specialSeats: boolean = false;
  ticketsSeats: any[] = [];
  configureOnly: boolean = false;
  allowedLevelNames: Set<string> | null = null;

  // Butacas especiales del recinto (sillas, movilidad reducida...) entre las que
  // puede elegir una entrada nueva, y los conjuntos que ya usan otras entradas
  // para poder copiarlos de un clic. Los monta quien abre el diálogo a partir de
  // las entradas del espacio: una butaca es "especial" porque alguna entrada la
  // nombra, no porque el mapa la marque.
  specialSeatsPool: any[] = [];
  specialSeatGroups: { name: string; seatIds: number[] }[] = [];

  constructor(
    private formBuilder: FormBuilder,
    private dialog: MatDialog,
    public formatter: NgbDateParserFormatter,
    @Optional() @Inject(MAT_DIALOG_DATA) public data: any,
    @Optional() private dialogRef: MatDialogRef<NewTicketComponent>,
  ) {}

  ngOnInit(): void {
    this.entrada = this.formBuilder.group({
      name: ['', [Validators.required, Validators.maxLength(50)]],
      active: [true],
      price: [],
      only_tpv_sales: [false],
      allow_discounts: [true],
      levels: [],
      sessions: [],
      special_seats: [false],
      seats: [],
    });
    this.ticketsLevels = [];
    if (this.data) {
      this.ticket = this.data.ticket;
      this.configureOnly = this.data.configureOnly || false;
      this.allowedLevelNames = this.data.allowedLevelNames ?? null;
      this.specialSeatsPool = this.data.specialSeatsPool || [];
      this.specialSeatGroups = this.data.specialSeatGroups || [];
      this.useMapVenue = this.data.useMapVenue;
      this.levels = this.useMapVenue ? this.data.levels : [];
      this.sessions = this.data.sessions || [];
      this.idEvent = this.data.idEvent;
      // Las zonas se listan por prioridad de compra, igual que la tabla de entradas.
      // Se ordena una copia para no tocar el array del componente padre.
      [...(this.levels ?? [])]
        .sort((a: any, b: any) => this.getLevelOrderBuy(a) - this.getLevelOrderBuy(b))
        .forEach((element) => {
          this.ticketsLevels.push({
            id: element.id,
            price: null,
            name: element.name,
            color: element.color,
          });
        });


      this.allowSubscription = this.data.venue?.allow_subscription;
      this.allowTicketSpecial = !this.data.map;
      this.selectedZones = ['all'];
      this.previousZones = ['all'];
      if (this.sessions.length === 1) {
        this.selectedSessions = [this.sessions[0]];
      }
    }
    if (this.ticket) {
      let levelsTicket = this.idEvent
        ? this.ticket.ticket_levels
        : (this.ticket.ticket_levels || this.ticket.levels);
      let ticket_seats = this.ticket.ticket_seats;
      if (levelsTicket) {
        levelsTicket.forEach((element: any) => {
          let level = this.ticketsLevels.find(
            (value) => value.id == element.id || value.id == element.level_id,
          );
          if (level) {
            level.price = element.price ?? null;
          }
        });
      }
      if (ticket_seats && ticket_seats.length > 0) {
        ticket_seats.forEach((seat: any) => {
          let level = this.ticketsLevels.find(
            (value) => value.id == seat.seat?.id_level,
          );
          // La butaca puede apuntar a un nivel que no está entre las zonas de este
          // evento (entrada base de otra versión del mapa). Sin esta comprobación
          // el diálogo revienta al abrirse y no se puede configurar la entrada.
          if (level) {
            level.price = seat.price ?? null;
          }
          seat.level_id = seat.seat?.id_level;
        });
      }
      if (this.ticket.sessions && this.ticket.sessions.length > 0) {
        this.selectedSessions = this.ticket.sessions;
      }
      this.specialSeats = this.ticket.special_seats || false;
      this.ticketsSeats = this.ticket.ticket_seats || [];
      this.entrada.setValue({
        name: this.ticket.name,
        active: this.ticket.active,
        price: this.ticket.price ?? null,
        only_tpv_sales: this.ticket.only_tpv_sales,
        allow_discounts: this.ticket.allow_discounts !== false,
        levels: this.useMapVenue && !this.specialSeats ? this.ticketsLevels : null,
        sessions: this.ticket.sessions || [],
        special_seats: this.ticket.special_seats || false,
        seats: this.ticket.ticket_seats || [],
      });
      this.edit = true;
    }
  }

  // Devuelve el orderBuy de un nivel (soporta camelCase y snake_case).
  // Los mapas guardados sin prioridad quedan al final, en el orden que manda la API.
  private getLevelOrderBuy(level: any): number {
    const val = level?.orderBuy ?? level?.order_buy;
    return val != null ? +val : Infinity;
  }

  editOnlyTpv(event: any) {
    this.entrada.controls['only_tpv_sales'].setValue(event.checked);
  }

  editLevelPrice(event: any, level: any, index: any) {
    const value = event.target.value;
    this.ticketsLevels[index].price = value !== '' ? (+value).toFixed(2) : null;
    if (this.specialSeats) {
      this.ticketsSeats.forEach((seat: any) => {
        if (seat.seat.id_level === level.id) {
          seat.price = this.ticketsLevels[index].price;
        }
      });
    }
    this.entrada.controls['levels'].setValue(!this.specialSeats ? this.ticketsLevels : null);
    this.entrada.controls['seats'].setValue(this.ticketsSeats);
  }

  // Solo al crear una entrada nueva en un recinto con mapa y butacas especiales
  // ya definidas. Configurando una entrada base del evento no se toca: sus butacas
  // vienen dadas por la entrada del espacio.
  canChooseSpecialSeats(): boolean {
    return !this.configureOnly && this.useMapVenue && this.specialSeatsPool.length > 0;
  }

  toggleSpecialSeats(checked: boolean) {
    this.specialSeats = checked;
    this.entrada.controls['special_seats'].setValue(checked);

    if (!checked) {
      this.ticketsSeats = [];
    } else if (this.ticketsSeats.length === 0 && this.specialSeatGroups.length === 1) {
      // Con un único conjunto (lo normal: "las sillas") no tiene sentido obligar a
      // marcarlo a mano.
      this.selectGroup(this.specialSeatGroups[0]);
    }

    this.syncSeatsControl();
  }

  // La entrada se aplica a un grupo entero de butacas especiales ("las sillas",
  // "movilidad reducida"), no a butacas sueltas: es como lo piensa quien programa
  // el teatro. El grupo se elige, no se acumula.
  selectGroup(group: { name: string; seatIds: number[] }) {
    const ids = new Set(group.seatIds);
    this.ticketsSeats = this.specialSeatsPool
      .filter((seat: any) => ids.has(seat.id))
      // Misma forma que las butacas que llegan de la API (`ticket_seats`), que es
      // lo que leen levelIdsWithSeats, editLevelPrice y quien recoge el diálogo.
      .map((seat: any) => ({ seat, level_id: seat.id_level, price: null }));
    this.syncSeatsControl();
  }

  isGroupSelected(group: { name: string; seatIds: number[] }): boolean {
    if (this.ticketsSeats.length !== group.seatIds.length) {
      return false;
    }
    const ids = new Set(group.seatIds);
    return this.ticketsSeats.every((ticketSeat: any) => ids.has(ticketSeat.seat?.id));
  }

  private syncSeatsControl() {
    this.entrada.controls['seats'].setValue(this.ticketsSeats);
    // Una entrada de butacas especiales no se cobra por zona: el precio de cada
    // zona se reparte entre sus butacas (ver editLevelPrice), así que los niveles
    // viajan a null igual que hace el guardado.
    this.entrada.controls['levels'].setValue(this.specialSeats ? null : this.ticketsLevels);
  }

  onZoneSelectionChange() {
    const current = this.selectedZones;
    const justAdded = current.filter((v: any) => !this.previousZones.includes(v));

    if (justAdded.includes('all')) {
      this.selectedZones = ['all'];
    } else if (justAdded.length > 0 && current.includes('all')) {
      this.selectedZones = current.filter((v: any) => v !== 'all');
    } else if (current.length === 0) {
      this.selectedZones = ['all'];
    }

    this.previousZones = [...this.selectedZones];
  }

  // Zonas en las que esta entrada tiene butacas. Solo tiene sentido en las entradas
  // de butacas especiales, que no se venden por zona: el precio se reparte entre sus
  // butacas, y una zona sin butacas suyas no tiene nada que cobrar.
  private levelIdsWithSeats(): Set<number> {
    return new Set(
      (this.ticketsSeats || [])
        .map((seat: any) => Number(seat.seat?.id_level))
        .filter((id: number) => !isNaN(id)),
    );
  }

  isLevelAllowed(level: any): boolean {
    if (this.specialSeats) {
      // Escribir un precio en una zona sin butacas de esta entrada no hacía nada
      // (editLevelPrice no encuentra a quién aplicárselo) pero el campo se dejaba
      // rellenar, así que parecía guardado.
      const levelsWithSeats = this.levelIdsWithSeats();
      if (levelsWithSeats.size > 0) {
        return levelsWithSeats.has(Number(level.id));
      }
    }
    return !this.allowedLevelNames || this.allowedLevelNames.has(level.name);
  }

  getFilteredLevels() {
    if (this.selectedZones.includes('all')) {
      return this.ticketsLevels;
    }
    return this.ticketsLevels.filter((level) =>
      this.selectedZones.includes(level.id),
    );
  }

  getOriginalIndex(level: any) {
    return this.ticketsLevels.findIndex((l) => l.id === level.id);
  }

  saveTicket() {
    if (this.entrada.invalid) {
      this.openInfo('Entrada no valida. Añade un nombre.');
      return;
    }

    if (this.sessions.length > 0 && this.selectedSessions.length === 0) {
      this.openInfo('Debes seleccionar al menos una sesión.');
      return;
    }

    if (this.specialSeats && this.ticketsSeats.length === 0) {
      this.openInfo('Elige a qué butacas se aplica esta entrada.');
      return;
    }

    if (this.priceMissing()) {
      this.openInfo('Añade un precio a la entrada para poder guardarla.');
      return;
    }

    if (this.hasNegativePrice()) {
      this.openInfo('El precio de la entrada no puede ser negativo.');
      return;
    }

    if (this.entrada.valid) {
      if (this.ticket) {
        this.entrada.value.id = this.ticket.id;
      }
      this.entrada.controls['sessions'].setValue(this.selectedSessions);
      const levelsToSave = !this.specialSeats ? this.ticketsLevels.filter((l: any) => this.isLevelAllowed(l)) : null;
      this.entrada.controls['levels'].setValue(levelsToSave);
      this.entrada.controls['seats'].setValue(this.specialSeats ? this.ticketsSeats : []);
      this.dialogRef.close(this.entrada.value);
    } else {
      this.openInfo('Entrada no valida. Comprueba todos los campos');
    }
  }

  hasNegativePrice(): boolean {
    // Sin excepción para las butacas especiales: isLevelAllowed ya deja fuera las
    // zonas que no les corresponden, así que el recorrido por zonas vale para ambas.
    if (this.levels?.length > 0) {
      const allowedLevels = this.ticketsLevels.filter((l: any) => this.isLevelAllowed(l));
      return allowedLevels.some((l: any) => l.price !== null && l.price !== undefined && l.price !== '' && Number(l.price) < 0);
    }
    const price = this.entrada.value.price;
    return price !== null && price !== undefined && price !== '' && Number(price) < 0;
  }

  priceMissing(): boolean {
    if (this.specialSeats) {
      // Las zonas con butacas de esta entrada han de llevar precio TODAS: el backend
      // guarda a 0 la butaca que llegue sin él (ver syncTicketPricing), y esas
      // butacas acabarían a la venta gratis.
      if (this.levelIdsWithSeats().size === 0) {
        return false;
      }
      return this.ticketsLevels
        .filter((l: any) => this.isLevelAllowed(l))
        .some((l: any) => l.price === null || l.price === undefined || l.price === '');
    }
    if (this.levels?.length > 0) {
      const allowedLevels = this.ticketsLevels.filter((l: any) => this.isLevelAllowed(l));
      return allowedLevels.every((l: any) => l.price === null || l.price === undefined || l.price === '');
    }
    const price = this.entrada.value.price;
    return price === null || price === undefined || price === '';
  }

  getSessionDateString(session: any): string {
    if (!session.start_date) {
      return 'Sesión sin fecha';
    }
    const date = new Date(session.start_date);
    return formatDate(date, 'dd/MM/yyyy - HH:mm', 'es') + 'h';
  }

  openInfo(msg: string) {
    this.dialog.open(InfoCardComponent, {
      panelClass: 'info-dialog',
      data: {
        icon: false,
        text: msg,
        btnCancel: false,
      },
    });
  }

  preventNegative(event: KeyboardEvent) {
    if (['-', '+', 'e', 'E'].includes(event.key)) {
      event.preventDefault();
    }
    if (event.key === 'ArrowDown') {
      const input = event.target as HTMLInputElement;
      if (input.value === '' || Number(input.value) <= 0) {
        event.preventDefault();
      }
    }
  }
}
